import { render, staticRenderFns } from "./ShowReportForm.vue?vue&type=template&id=20f87172&"
import script from "./ShowReportForm.vue?vue&type=script&lang=js&"
export * from "./ShowReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports